import SimpleTable from "../CustomTable/SimpleTable";

const OrderTypeTable = ({ orders }) => {
  const ordersHeader = [
    { title: "دستور", key: "orderName" },
    { title: "کد دستور", key: "orderCode" },
  ];
  const ordersTabeleData = [];
  orders.value.forEach((order) => {
    ordersTabeleData.push({
      orderName: order.order_type_name,
      orderCode: order.order_type_code,
    });
  });

  return (
    <>
      <SimpleTable
        hasIndex={true}
        hasLink={false}
        darkHeader={true}
        data={ordersTabeleData}
        header={ordersHeader}
      />
    </>
  );
};
export default OrderTypeTable;
